import Modal from "components/Modal/Modal";
import { settingsService } from "Dashboard/services/settings.service";
import { ChangeEvent, useCallback, useState } from "react";
import Cropper from "react-easy-crop";
import { getCroppedImg } from "utils/canvasUtils";
import { toast } from "react-toastify";
import { IUser } from "authentication/domain/IUser";
import { authServices } from "authentication/services/auth.service";
import { ImageUploadType } from "Dashboard/domain/ImageUploadType";

interface IProps {
  setClickOutsideActive: Function;
  isOpen: boolean;
  setIsOpen: Function;
  refresh: Function;
  user: IUser | null;
  aspect: number;
  uploadType: ImageUploadType;
}

const UploadPhotoModal = ({
  setClickOutsideActive,
  isOpen,
  setIsOpen,
  refresh,
  user = null,
  aspect,
  uploadType,
}: IProps) => {
  const [imageSrc, setImageSrc] = useState<string | null>(null);
  const [crop, setCrop] = useState({ x: 0, y: 0 });
  const [zoom, setZoom] = useState(1);
  const [croppedAreaPixels, setCroppedAreaPixels] = useState<Object | null>(
    null
  );

  const onCropComplete = useCallback((_: any, croppedAreaPixels: any) => {
    setCroppedAreaPixels(croppedAreaPixels);
  }, []);

  const onFileChange = async (e: ChangeEvent<HTMLInputElement>) => {
    if (e.target.files && e.target.files.length > 0) {
      const file = e.target.files[0];
      let imageDataUrl = await readFile(file);
      setImageSrc(imageDataUrl);
    }
  };

  function readFile(file: Blob): Promise<string> {
    return new Promise((resolve) => {
      const reader = new FileReader();
      reader.addEventListener(
        "load",
        () => resolve(reader.result as string),
        false
      );
      reader.readAsDataURL(file);
    });
  }

  const closeDialog = () => {
    setIsOpen(false);
    setClickOutsideActive(true);
    setCrop({ x: 0, y: 0 });
    setZoom(1);
    setImageSrc(null);
  };

  const uploadImage = async () => {
    try {
      if (croppedAreaPixels) {
        const croppedImage = await getCroppedImg(imageSrc, croppedAreaPixels);
        let response;

        if (user) {
          if (uploadType === ImageUploadType.SPECIFIC_LOGO) {
            response = await authServices.uploadProfilePictureForSpecificUser(
              croppedImage,
              user.username
            );
          } else if (uploadType === ImageUploadType.MY_LOGO) {
            response = await authServices.uploadMyProflePicture(croppedImage);
          }
        } else {
          if (uploadType === ImageUploadType.MEMORANDUM) {
            response = await settingsService.uploadMemorandumLogo(croppedImage);
          }
        }
        if (response && response.message === "success") {
          closeDialog();
          refresh();
          toast.success("Slika je uspešno uploadovana.");
        } else {
          toast.error("Došlo je do greške prilikom uploada! Pokušajte ponovo.");
        }
      }
    } catch (e) {
      toast.error("Došlo je do greške prilikom uploada! Pokušajte ponovo.");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      title="Upload slike"
      onClose={closeDialog}
      onClick={imageSrc ? uploadImage : undefined}
    >
      {imageSrc ? (
        <div className="crop-container">
          <Cropper
            crop={crop}
            zoom={zoom}
            onCropChange={setCrop}
            onZoomChange={setZoom}
            onCropComplete={onCropComplete}
            image={imageSrc}
            aspect={aspect}
          />
        </div>
      ) : (
        <>
          <div>Selektujte odgovarajucu sliku.</div>
          <input type="file" onChange={onFileChange} accept="image/*" />
        </>
      )}
    </Modal>
  );
};

export default UploadPhotoModal;
